import React from 'react';
import { Outlet } from 'react-router-dom';
import { useClassnames } from '@wb-tech/ui-react';

import styles from './index.module.pcss';

export const SDKLayout = () => {
    const cn = useClassnames(styles);

    return (
        <div className={cn('sdk-layout')}>
            <Outlet />
        </div>
    );
};
